define(["require", "exports", "../utils/utils"], function (require, exports, utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ValidationFieldInput = (function () {
        function ValidationFieldInput() {
            this.htmlStructure = '<div class = "flex flex-wrap w-2/3 px-2 justify-center" > ' +
                '<div class = "w-full lg:w-2/3 mb-4" >' +
                '<div class="flex w-full justify-center">' +
                '<label for= "txtForeignDocument" class= "inline-block tracking-wide text-black text-sm mb-2">' +
                '{0}:' +
                '</label>' +
                '</div>' +
                '<div class= "flex w-full justify-end items-center mb-4" >' +
                '{1}' +
                '</div>' +
                '</div>' +
                '</div>';
            this.labelMaskPrefixStructure = '<div class="flex w-1/4 mb-4 justify-end text-sm lg:text-lg">' +
                '<label>{0}</label>' +
                '</div>';
            this.labelMaskStructure = '<div class="inline-block w-1/4 mb-4 pl-2 mr-10 text-sm lg:text-lg">' +
                '<label>{0}</label>' +
                '</div>';
            this.validationFieldsConfig = {
                NomeMae: {
                    'label': 'Nome da mãe',
                    'firstValidIndex': 0
                },
                Cep: {
                    'first': {
                        'label': 'primeiros dígitos do seu CEP'
                    },
                    'last': {
                        'label': 'últimos dígitos do seu CEP'
                    },
                    'mask': 'XXXXX-XXX',
                    'firstValidIndex': 0
                },
                Celular: {
                    'first': {
                        'label': 'primeiros dígitos do seu Celular'
                    },
                    'last': {
                        'label': 'últimos dígitos do seu Celular'
                    },
                    'mask': '(XX)X XXXX-XXXX',
                    'firstValidIndex': 5,
                    'firstIndex': 3
                },
                TelefoneFixo: {
                    'first': {
                        'label': 'primeiros dígitos do seu Telefone Fixo'
                    },
                    'last': {
                        'label': 'últimos dígitos do seu Telefone Fixo'
                    },
                    'mask': '(XX) XXXX-XXXX',
                    'firstValidIndex': 3,
                    'firstIndex': 2
                },
                SegundoTelefoneFixo: {
                    'first': {
                        'label': 'primeiros dígitos do seu Segundo Telefone Fixo'
                    },
                    'last': {
                        'label': 'últimos dígitos do seu Segundo Telefone Fixo'
                    },
                    'mask': '(XX) XXXX-XXXX',
                    'firstValidIndex': 3,
                    'firstIndex': 2
                },
                Rg: {
                    'first': {
                        'label': 'primeiros dígitos do seu RG'
                    },
                    'last': {
                        'label': 'últimos dígitos do seu RG'
                    },
                    'mask': 'XX.XXX.XXX-X',
                    'firstValidIndex': 0
                },
                Cpf: {
                    'first': {
                        'label': 'primeiros dígitos do seu CPF'
                    },
                    'last': {
                        'label': 'últimos dígitos do seu CPF'
                    },
                    'mask': 'XXX.XXX.XXX-XX',
                    'firstValidIndex': 0
                },
                DoctoEstrangeiro: {
                    'label': 'Documento Estrangeiro',
                    'firstValidIndex': 0
                },
                Email: {
                    'label': 'E-mail',
                    'firstValidIndex': 0
                },
                Cidade: {
                    'label': 'Cidade',
                    'firstValidIndex': 0
                },
                Bairro: {
                    'label': 'Bairro',
                    'firstValidIndex': 0
                },
                DataNascimento: {
                    'first': {
                        'label': 'Dia e o mês do seu nascimento'
                    },
                    'last': {
                        'label': 'Ano do seu nascimento'
                    },
                    'mask': 'XX/XX/XXXX',
                    'firstValidIndex': 0
                }
            };
            this.propertiesWithoutNumberOrCharactersLabel = [
                'DataNascimento'
            ];
            this.propertiesThatKeepMaskCharactersInInputLength = [
                'DataNascimento'
            ];
            this.numbers = {
                2: 'Dois',
                3: 'Três',
                4: 'Quatro',
                5: 'Cinco',
            };
        }
        ValidationFieldInput.prototype.GetInputStructure = function (isDefault) {
            if (isDefault === void 0) { isDefault = false; }
            return "<div class=\"inline-block " + (isDefault ? 'w-full' : 'w-1/3') + " mb-4 ml-1\">" +
                '<input id="{0}" name="{1}" maxlength="{2}" data-index={3} minlength="{4}" class="rounded leading-tight w-px flex-1 block appearance-none w-full border border-gray-400 hover:border-gray-500 focus:border-gray-600 focus:outline-none py-3 px-3 shadow" type="text" required />' +
                '</div>';
        };
        ValidationFieldInput.prototype.BuildMaskForStart = function (maskTemplate, amountOfDigits, firstValidIndex, propertyName) {
            var _a, _b;
            var maskStructure = '';
            var specialCharacters = 0;
            for (var i = 0; i < amountOfDigits; i++) {
                if (maskTemplate[i + firstValidIndex] !== "X")
                    specialCharacters++;
            }
            var removedPart = maskTemplate.substring(0, firstValidIndex + amountOfDigits + specialCharacters);
            var removedPartPrefix = '';
            if (this.HasWhiteSpace(removedPart)) {
                var splittedRemovedPart = removedPart.split(' ');
                removedPartPrefix = splittedRemovedPart[0] + ' ';
                removedPart = splittedRemovedPart[1];
                maskStructure += utils_1.format(this.labelMaskPrefixStructure, [removedPartPrefix]);
            }
            var label = maskTemplate.substring(firstValidIndex + amountOfDigits + specialCharacters);
            var inputStructure = this.GetInputStructure();
            var keepMaskCharacters = this.propertiesThatKeepMaskCharactersInInputLength.includes(propertyName);
            var length = (firstValidIndex !== 0 || keepMaskCharacters ? removedPart.length : removedPart.length - specialCharacters).toString();
            maskStructure += utils_1.format(inputStructure, [propertyName, propertyName, length, (_b = (_a = this.validationFieldsConfig[propertyName]) === null || _a === void 0 ? void 0 : _a.firstIndex) !== null && _b !== void 0 ? _b : 0, length]);
            maskStructure += utils_1.format(this.labelMaskStructure, [label]);
            return maskStructure;
        };
        ValidationFieldInput.prototype.HasWhiteSpace = function (s) {
            return s.indexOf(' ') >= 0;
        };
        ValidationFieldInput.prototype.BuildMaskForLast = function (maskTemplate, amountOfDigits, propertyName) {
            var _a, _b;
            var maskStructure = '';
            var specialCharacters = 0;
            for (var i = 0; i < amountOfDigits; i++) {
                if (maskTemplate[(maskTemplate.length - 1) - i] !== "X")
                    specialCharacters++;
            }
            var removedPart = maskTemplate.substring(0, maskTemplate.length - (amountOfDigits + specialCharacters));
            var label = maskTemplate.substring(maskTemplate.length - (amountOfDigits));
            var inputStructure = this.GetInputStructure(false);
            maskStructure += utils_1.format(this.labelMaskPrefixStructure, [removedPart]);
            maskStructure += utils_1.format(inputStructure, [propertyName, propertyName, label.length.toString(), (_b = (_a = this.validationFieldsConfig[propertyName]) === null || _a === void 0 ? void 0 : _a.firstIndex) !== null && _b !== void 0 ? _b : 0, label.length.toString()]);
            maskStructure += utils_1.format(this.labelMaskStructure, ['']);
            return maskStructure;
        };
        ValidationFieldInput.prototype.BuildDefaultInput = function (propertyName, firstIndex, sourceLength) {
            var inputStructure = this.GetInputStructure(true);
            inputStructure = utils_1.format(inputStructure, [propertyName, propertyName, sourceLength.toString(), firstIndex.toString(), sourceLength.toString()]);
            return inputStructure;
        };
        ValidationFieldInput.prototype.GetHtmlWithValues = function (validationData) {
            var fieldLabel = '';
            if (validationData.characterPosition === null)
                fieldLabel = this.validationFieldsConfig[validationData.propertyName]['label'];
            else {
                fieldLabel = this.validationFieldsConfig[validationData.propertyName][validationData.characterPosition]['label'];
            }
            var numberOfDigits = validationData.numberOfCharacters !== null ? this.numbers[validationData.numberOfCharacters] + " (" + validationData.numberOfCharacters + ")" : '';
            var label = this.propertiesWithoutNumberOrCharactersLabel.includes(validationData.propertyName) ? fieldLabel : numberOfDigits + " " + fieldLabel;
            var maskFullStructure = '';
            switch (validationData.characterPosition) {
                case 'first':
                    maskFullStructure = this.BuildMaskForStart(this.validationFieldsConfig[validationData.propertyName]['mask'], validationData.numberOfCharacters, this.validationFieldsConfig[validationData.propertyName]['firstValidIndex'], validationData.propertyName);
                    break;
                case 'last':
                    maskFullStructure = this.BuildMaskForLast(this.validationFieldsConfig[validationData.propertyName]['mask'], validationData.numberOfCharacters, validationData.propertyName);
                    break;
                default:
                    maskFullStructure = this.BuildDefaultInput(validationData.propertyName, this.validationFieldsConfig[validationData.propertyName]['firstValidIndex'], validationData.sourceLength);
            }
            this.htmlStructure = utils_1.format(this.htmlStructure, [label, maskFullStructure]);
            return this.htmlStructure;
        };
        return ValidationFieldInput;
    }());
    exports.default = ValidationFieldInput;
});
